// ============================================================
// Students Mock Data
// ============================================================

const firstNamesM = ['Aarav', 'Vihaan', 'Arjun', 'Sai', 'Krishna', 'Ishaan', 'Rahul', 'Rohan', 'Amit', 'Vikram', 'Rishi', 'Karan'];
const firstNamesF = ['Saanvi', 'Aanya', 'Pari', 'Diya', 'Meera', 'Neha', 'Priya', 'Kavya', 'Riya', 'Anjali', 'Sneha', 'Tanvi'];
const lastNames = ['Sharma', 'Verma', 'Patel', 'Singh', 'Kumar', 'Das', 'Bose', 'Kapoor', 'Reddy', 'Rao', 'Gupta', 'Nair'];

export const mockStudents = [];

const schoolCounts = {
  'school-1': { count: 320, boys: 170, girls: 150 },
  'school-2': { count: 415, boys: 215, girls: 200 },
  'school-3': { count: 280, boys: 140, girls: 140 },
  'school-4': { count: 512, boys: 262, girls: 250 },
  'school-5': { count: 350, boys: 0, girls: 350 }
};

let stdId = 1;

for (const [schoolId, {boys, girls}] of Object.entries(schoolCounts)) {
  for (let i = 0; i < boys; i++) {
    const fName = firstNamesM[Math.floor(Math.random() * firstNamesM.length)];
    const lName = lastNames[Math.floor(Math.random() * lastNames.length)];
    mockStudents.push({
      id: `std-${stdId}`,
      schoolId: schoolId,
      admissionNumber: `ADM2024${stdId.toString().padStart(4, '0')}`,
      admissionDate: "2024-03-15",
      firstName: fName,
      middleName: "",
      lastName: lName,
      gender: "Male",
      dateOfBirth: "2014-05-20",
      bloodGroup: "O+",
      category: "General",
      religion: "Hindu",
      nationality: "Indian",
      photo: null,
      classId: `class-${(i % 12) + 1}`,
      className: `Grade ${(i % 12) + 1}`,
      sectionId: ((i % 12) + 1) === 1 ? 'sec-1' : ((i % 12) + 1) === 2 ? 'sec-3' : ((i % 12) + 1) === 5 ? 'sec-5' : `sec-${(i % 12) + 1}-A`,
      sectionName: "Section A",
      rollNumber: (i + 1).toString(),
      house: "Red",
      session: "2024-2025",
      previousSchool: "Previous School",
      admissionType: Math.random() < 0.15 ? "New" : (Math.random() < 0.1 ? "Transfer" : "Regular"),
      parentId: `parent-${stdId}`,
      fatherName: `Mr. ${lName}`,
      phone: "+91 9876543210",
      medicalConditions: "None",
      allergies: "None",
      doctorName: "Dr. Sharma",
      emergencyContact: "+91 9876543211",
      status: "active"
    });
    stdId++;
  }
  for (let i = 0; i < girls; i++) {
    const fName = firstNamesF[Math.floor(Math.random() * firstNamesF.length)];
    const lName = lastNames[Math.floor(Math.random() * lastNames.length)];
    mockStudents.push({
      id: `std-${stdId}`,
      schoolId: schoolId,
      admissionNumber: `ADM2024${stdId.toString().padStart(4, '0')}`,
      admissionDate: "2024-03-15",
      firstName: fName,
      middleName: "",
      lastName: lName,
      gender: "Female",
      dateOfBirth: "2014-05-20",
      bloodGroup: "B+",
      category: "General",
      religion: "Hindu",
      nationality: "Indian",
      photo: null,
      classId: `class-${(i % 12) + 1}`,
      className: `Grade ${(i % 12) + 1}`,
      sectionId: ((i % 12) + 1) === 1 ? 'sec-2' : ((i % 12) + 1) === 2 ? 'sec-4' : `sec-${(i % 12) + 1}-B`,
      sectionName: "Section B",
      rollNumber: (i + 1).toString(),
      house: "Blue",
      session: "2024-2025",
      previousSchool: "Previous School",
      admissionType: Math.random() < 0.15 ? "New" : (Math.random() < 0.1 ? "Transfer" : "Regular"),
      parentId: `parent-${stdId}`,
      fatherName: `Mr. ${lName}`,
      phone: "+91 9876543212",
      medicalConditions: "None",
      allergies: "None",
      doctorName: "Dr. Sharma",
      emergencyContact: "+91 9876543213",
      status: "active"
    });
    stdId++;
  }
}
